// Backend the app talks to.
//
// Defaults to the deployed FixDesk API, so nothing changes for a normal build.
// Point it at a local backend without editing this file by creating
// `FE/.env.local` (gitignored by Create React App):
//
//     REACT_APP_API_BASE_URL=http://127.0.0.1:8003/
//
// Restart `npm start` afterwards — CRA reads env files only at startup.
const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "https://fixdesk.api.tecnospice.com/";

export default API_BASE_URL;
